import {
  ArrowsPointingOutIcon,
  PencilIcon,
  PhotoIcon
} from '@heroicons/react/24/outline';
import EditVerticesIcon from 'components/icons/edit-vertices-icon';
import { FootprintModeToolbarItem } from './footprint-mode-toolbar-item';

export const FOOTPRINT_MODE_TOOLBAR_ITEMS: FootprintModeToolbarItem[] = [
  { id: 'draw', icon: PencilIcon, label: 'Draw Footprint' },
  { id: 'edit', icon: EditVerticesIcon, label: 'Edit Footprint' },
  { id: 'scale', icon: ArrowsPointingOutIcon, label: 'Scale Footprint' },
  { id: 'image', icon: PhotoIcon, label: 'Adjust Image' }
];

export function getVisibleFootprintModeToolbarItems(
  showImageMode: boolean
): FootprintModeToolbarItem[] {
  return FOOTPRINT_MODE_TOOLBAR_ITEMS.filter(
    (item) => item.id !== 'image' || showImageMode
  );
}
